module.exports = fox._r("images/empty-icon-message.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-icon-message.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-icon-message.png
// module id = 93
// module chunks = 2